module.exports = __webpack_public_path__ + "img/375_banner_3.1d01e66c.jpg";